<template>
  <div class="about" style="background-color: aqua; display: flex; " >
    <div id="about"  style="width: 500px; height: 800px;"></div>
    <h1>This is an about page</h1>
    <MindElixirDialog :visible.sync="show" />

    <!-- <iframe src="https://emoawps.pumc.edu.cn/weboffice/office/w/1843558171183095810?_w_appid=KWIZITBBNCZUKHHU&_w_third_appid=KWIZITBBNCZUKHHU&_w_third_file_id=1843558171183095810&route_key=&wpsPreview=1110110&simple&hidecmb&readonly"></iframe> -->
  </div>
</template>


<script>
import MindElixirDialog from '../components/MindElixirDialog.vue';
export default {

  components:{
        MindElixirDialog
  },
  data(){
    return {
      show:true

    }
  },

  mounted(){
    this.$store.state.showNaotu = true
  }

}
</script>